module.exports = __webpack_public_path__ + "static/img/img-about-11.f9259ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-11.png
// module id = H9XT
// module chunks = 0